<template>
  <div>
    <div v-if="displayOldGroups">
      <div v-if="!isChangeOfSuggestedGroup" data-cy="all-movable-group-channels">
        <i18n-t keypath="news.content_move.grade_selection_modal.description"
                tag="p"
                class="fz-small gray-300 mb-3"
        >
          <template #description_bold>
            <span class="font-weight-bold black">{{ $t('news.content_move.grade_selection_modal.description_bold') }}</span>
          </template>
        </i18n-t>

        <sdui-alert
          variant="info-inverted"
          :display-action-as-full-row="true"
          align-icon="top"
          icon-class="pt-4"
          alert-class="pl-0 pr-4 py-4"
          class="mb-3"
        >
          <template #content>
            <h5 class="gray-300 font-weight-light m-0 fz-small">{{ $t('news.content_move.grade_selection_modal.hint') }}</h5>
          </template>
        </sdui-alert>
      </div>
      <i18n-t
        v-else
        keypath="ui.content_move.grade_selection_modal.description_old_groups_1"
        tag="p"
        data-cy="change-of-suggested-old-group"
        class="fz-small gray-300 mb-3"
      >
        <template #descriptionOldGroups1Bold>
          <span class="font-weight-bold black">{{ $t('ui.content_move.grade_selection_modal.description_old_groups_1_bold') }}</span>
        </template>
      </i18n-t>
    </div>
    <i18n-t
      v-else
      keypath="ui.content_move.grade_selection_modal.description_new_groups_1"
      tag="p"
      data-cy="change-of-suggested-new-group"
      class="fz-small gray-300 mb-3"
    >
      <template #descriptionNewGroups1Bold>
        <span class="font-weight-bold black">{{ $t('ui.content_move.grade_selection_modal.description_new_groups_1_bold') }}</span>
      </template>
    </i18n-t>

    <SList data-cy="grade-group-channels">
      <SListItem
        v-for="gradeGroupChannel in gradeGroupChannels"
        :key="gradeGroupChannel.id"
        :title="gradeGroupChannel.meta.displayname"
        icon="icon-group"
        icon-color="success"
        :description="$t('ui.content_move.grade_selection_modal.members_count', { count: gradeGroupChannel.users_count })"
        :right-action-label="isChangeOfSuggestedGroup ? $t('global.choose').toLowerCase() : ''"
        right-action-label-highlighted
        @click="handleClick(gradeGroupChannel)"
      />
      <template v-if="foreignGradeGroupChannels">
        <template v-for="shortcut in Object.keys(foreignGradeGroupChannels)">
          <SListItem
            v-for="gradeGroupChannel in foreignGradeGroupChannels[shortcut]"
            :key="gradeGroupChannel.id"
            :title="gradeGroupChannel.meta.displayname"
            icon="icon-group"
            icon-color="success"
            :description="$t('ui.content_move.grade_selection_modal.members_count', { count: gradeGroupChannel.users_count })"
          >
            <template v-if="isChangeOfSuggestedGroup" #right-action>
              <div class="d-flex">
                <span data-cy="foreign-group-channel-shortcut">{{ shortcut }}</span>
                <STooltip class="d-flex"
                          :title="$t('ui.content_move.grade_selection_modal.info_foreign_channels')"
                          placement="bottomright"
                >
                  <template #tooltip-trigger="{ triggerAttrs }">
                    <b-button v-bind="triggerAttrs"
                              variant="link"
                              class="p-0 mh-0 ml-1"
                              :aria-label="$t('global.warning.title')"
                    >
                      <sdui-icon class="icon-info-o d-flex" />
                    </b-button>
                  </template>
                </STooltip>
              </div>
            </template>
          </SListItem>
        </template>
      </template>
    </SList>

    <p v-if="isChangeOfSuggestedGroup && !displayOldGroups"
       class="fz-small gray-300 mt-4 mb-0"
       data-cy="change-of-suggested-new-group"
    >
      {{ $t('ui.content_move.grade_selection_modal.description_new_groups_2') }}
    </p>
  </div>
</template>

<script>
import SduiAlert from 'src/components/miscellaneous/ui/common/SduiAlert.vue'
import STooltip from 'src/components/base/STooltip.vue'

export default {
  name: 'SduiContentMoveGradeSelection',

  components: {
    SduiAlert,
    STooltip,
  },

  props: {
    displayOldGroups: {
      type: Boolean,
      default: true,
    },

    isChangeOfSuggestedGroup: {
      type: Boolean,
      default: false,
    },

    gradeGroupChannels: {
      type: Array,
      required: true,
    },

    foreignGradeGroupChannels: {
      type: Object,
      default: () => {},
    },
  },

  data: () => ({}),

  emits: ['grade-channel-selected'],

  methods: {
    handleClick(channel) {
      if (!this.isChangeOfSuggestedGroup) return this.redirectToGradeGroupChannel(channel.id)
      this.$emit('grade-channel-selected', channel)
    },

    redirectToGradeGroupChannel(channelId) {
      this.$router.push({ name: 'channel-single-chat', hash: '#read', params: { id: channelId } })
    },
  },
}
</script>
